import React from 'react';
import { formatCurrency, formatNumber } from '../../utils/formatters';
import { Trash2 } from 'lucide-react';
import './PropertyInfoPanel.css';

const PropertyInfoPanel = ({ property, savedScenarios, onLoadScenario, onDeleteScenario }) => {
    if (!property) return null;

    const images = property.photos && property.photos.length > 0
        ? property.photos
        : (property.primary_photo_url ? [property.primary_photo_url] : []);

    return (
        <div className="property-info-panel">
            {images.length > 0 && (
                <img
                    className="pip-photo"
                    src={images[0]}
                    alt={property.address}
                />
            )}

            <h3 className="pip-address">{property.address}</h3>
            <p className="pip-location">{property.city}, {property.state}</p>

            <div className="pip-specs">
                {property.beds && <span>{property.beds} bd</span>}
                {property.baths && <span>{property.baths} ba</span>}
                {property.sqft && <span>{formatNumber(property.sqft)} sqft</span>}
                {property.year_built && <span>Built {property.year_built}</span>}
            </div>

            <div className="pip-price">{formatCurrency(property.list_price)}</div>

            <div className="pip-divider" />

            <h4 className="pip-section-title">Saved Scenarios</h4>

            {(!savedScenarios || savedScenarios.length === 0) ? (
                <p className="pip-empty">No saved scenarios yet</p>
            ) : (
                <div className="pip-scenario-list">
                    {savedScenarios.map(scenario => (
                        <div
                            key={scenario.id}
                            className="pip-scenario-item"
                            onClick={() => onLoadScenario(scenario)}
                        >
                            <div className="pip-scenario-info">
                                <span className="pip-scenario-name">{scenario.name}</span>
                                <span className="pip-scenario-date">
                                    {new Date(scenario.created_at).toLocaleDateString()}
                                </span>
                                {scenario.results?.cashOnCashROI !== undefined && (
                                    <span className="pip-scenario-roi">
                                        CoC: {scenario.results.cashOnCashROI.toFixed(1)}%
                                    </span>
                                )}
                            </div>
                            <button
                                className="pip-scenario-delete"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onDeleteScenario(scenario.id);
                                }}
                                aria-label="Delete scenario"
                            >
                                <Trash2 size={14} />
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default PropertyInfoPanel;
